$('.buy-section .addToCart').on('click', function() {
    var btn = $(this),
        variant_id = btn.data('variant'),
        productTitle = btn.data('product-title'),
        is_bundle = btn.data('bundle'),
        discountProperty = btn.data('discount-property');

    if (is_bundle == true) {
        var bundleItemsData = btn.data('bundle-items');
        var bundleItems = [];
        
        // Parse the bundle items if it's a string
        if (typeof bundleItemsData === 'string') {
            try {
                bundleItemsData = JSON.parse(bundleItemsData);
            } catch (e) {
                console.error('Error parsing bundle items:', e);
                return;
            }
        }
        
        // Extract items from the bundle data structure
        if (bundleItemsData && bundleItemsData.items && bundleItemsData.items[0]) {
            bundleItems = bundleItemsData.items[0];
        }
        
        var items = [];

        for (var i = 0; i < bundleItems.length; i++) {
            items.push({
                quantity: bundleItems[i].quantity,
                id: bundleItems[i].variant_id,
                properties: {
                    'Bundle': productTitle
                }
            });
        }

        $.ajax({
            url: '/cart/add.js',
            type: 'post',
            dataType: 'json',
            data: JSON.stringify({ items: items }),
            contentType: 'application/json',
            success: function(response) {
                console.log('Added bundle to cart with =>', items);

                setTimeout(function() {
                    if (typeof showVueCart !== 'undefined' && showVueCart == true) {
                        window.miniCart.refreshCart();
                    }
                }, 2000);
            },
            error: function(xhr, status, error) {
                console.error('Error adding bundle to cart:', error);
            }
        });

    } else {

        $.ajax({
            url: '/cart/add.json',
            type: 'post',
            dataType: 'json',
            data: {
                quantity: 1,
                id: variant_id,
                properties: {
                    'Discount': discountProperty
                }
            },
            success: function(response) {
                console.log('');
                console.log('%c' + response.title + "%c was added to cart.", 'color: green', 'color: black',);

                if (typeof showVueCart !== 'undefined' && showVueCart == true) {
                    window.miniCart.refreshCart();
                }
                var originalHtml = btn.html();
                btn.addClass('added');
                btn.html('added to cart!');
                btn.attr('disabled', true);

                setTimeout(function() {
                    btn.removeClass('added');
                    btn.html(originalHtml);
                    btn.attr('disabled', false);
                }, 4000);
            },
            error: function(response) {
                var errors = JSON.parse(response.responseText);
                console.log(errors.errors);
            }
        });

    }
});

